import { setCookie, checkCookie } from './cookie-helpers.js';
/**
 * Function to handle spotlight functionality.
 */
function spotlight() {
	const spotlightElement = document.querySelector(
		'dialog[data-modal="spotlight"]'
	);

	if (!spotlightElement) {
		return;
	}

	handleButtonClicks(spotlightElement);

	if (spotlightElement.classList.contains('offcanvas-spotlight')) {
		notificationSpotlight(spotlightElement);
	}

	if (spotlightElement.classList.contains('popup-spotlight')) {
		popupSpotlight(spotlightElement);
	}
}

/**
 * Initializes the notification spotlight module.
 *
 * @param {HTMLElement} el - The element representing the notification spotlight.
 * @returns {void}
 */
function notificationSpotlight(el) {
	const notificationSpotlight = el;
	const notificationSpotlightClosed = checkCookie(
		'notificationSpotlightClosed'
	);

	if (notificationSpotlightClosed) {
		return;
	}

	// Only start the logic when the "available" class is added to the notification
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class'
			) {
				if (notificationSpotlight.classList.contains('available')) {
					if (notificationSpotlight.classList.contains('drawer-open')) {
						// Immediately open the notification
						notificationSpotlight.show();
					} else if (notificationSpotlight.classList.contains('drawer-auto')) {
						// Add a delay of 5 seconds before opening
						setTimeout(() => {
							notificationSpotlight.show();
						}, 5000);
					}
				}
			}
		}
	});

	if (
		notificationSpotlight.classList.contains('drawer-auto') ||
		notificationSpotlight.classList.contains('drawer-open')
	) {
		observer.observe(notificationSpotlight, { attributes: true });
	}

	notificationSpotlight.addEventListener('close', (e) => {
		setCookie('notificationSpotlightClosed', 'true', 7);
	});
}

/**
 * Function to display a popup spotlight.
 *
 * @param {HTMLElement} el - The element representing the popup spotlight.
 * @returns {void}
 */
function popupSpotlight(el) {
	// init popup spotlight
	const popupSpotlight = el;
	const popupSpotlightClosed = checkCookie('popupSpotlightClosed');

	if (popupSpotlightClosed) {
		return;
	}

	popupSpotlight.addEventListener('close', (e) => {
		setCookie('popupSpotlightClosed', 'true', 7);
	});

	popupSpotlight.showModal();
}

/**
 * Handles button clicks inside the notification dialog using event delegation.
 * Closes the dialog and sets the appropriate cookie based on element class.
 *
 * @param {Element} element - The DOM element for the notification.
 */
function handleButtonClicks(element) {
	element.addEventListener('click', (event) => {
		if (event.target.classList.contains('btn')) {
			element.close();

			// Set the appropriate cookie based on element class
			if (element.classList.contains('notification-spotlight')) {
				setCookie('notificationSpotlightClosed', 'true', 7);
			} else if (element.classList.contains('popup-spotlight')) {
				setCookie('popupSpotlightClosed', 'true', 7);
			}
		}
	});
}

export { spotlight };
